import gql from 'graphql-tag';

export const GET_FUNNEL_SOURCE = gql`
  query getFunnelSource($userId: Int!) {
    originationSource(userId: $userId) {
      funnel
      id
    }
  }
`;

export const getOriginationSourceMock = {
  originationSource: {
    funnel: 'communitySolar',
    id: 5,
  },
};

export const getBuisnessOriginationSourceMock = {
  originationSource: {
    funnel: 'business',
    id: 6,
  },
};

export const REACTIVATE_PLAN = gql`
  mutation reactivatePlan($id: Int!) {
    reactivatePlan(id: $id) {
      success
      error
    }
  }
`;

export const planReactivationMock = {
  reactivatePlan: {
    success: true,
    error: null,
  },
};

export const planReactivationFailureMock = {
  reactivatePlan: {
    success: false,
    error: 'Error message',
  },
};
